import { ITopBarMessage } from "@cms/utils/interfaces/ui.interface";
import { useAppDispatch, useAppSelector } from "@cms/utils/store/hooks";
import { hideTopBarMessageAction } from "@cms/utils/store/slices/app.slice";
import clsx from "clsx";
import { useEffect } from "react";
import { FaLock } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { TransferControlIcon, ViewLogIcon } from "../icons";

interface MessageProps extends ITopBarMessage { }

const Message: React.FC<MessageProps> = (props) => {
    const { content, type, leftIcon, rightIcon } = props

    const renderIcon = (icon?: string) => {
        return {
            "Lock": <FaLock />,
            "TransferControl": <TransferControlIcon fill="white" />,
            "ViewLog": <ViewLogIcon fill="white" />,
        }[icon || ""] || null
    }

    return (
        <div
            className={clsx(
                // 'sticky top-0',
                'h-14 text-white flex justify-center items-center gap-2',
                {
                    info: 'bg-blue-500',
                    warning: 'bg-cs-700',
                    error: 'bg-red-700',
                    success: 'bg-[#027A48]',
                }[type]
            )}
        >
            {leftIcon && renderIcon(leftIcon)}
            <p>{content}</p>
            {rightIcon && renderIcon(rightIcon)}
        </div>
    )
}

export const TopBar = () => {
    const dispatch = useAppDispatch();
    const { pathname: pageId } = useLocation();
    const { messages } = useAppSelector((state) => state.app.topBarOptions);

    const message = messages[pageId];

    useEffect(() => {
        if (message && message.ttl) {
            setTimeout(() => {
                dispatch(hideTopBarMessageAction({ pageId }));
            }, message.ttl);
        }
    }, [message]);

    if (message) {
        return <Message {...message} />
    }

    return null
}
